export default {
  getGlobalTheme: (state) => state.globalTheme,
  menuTheme: (state) => state.menuTheme,
  toolbarTheme: (state) => state.toolbarTheme,
  drawer: (state) => state.drawer,
};
